<template>
<div class="home">
    <div id="app-32-map" class="is-full"></div>
</div>
</template>

<script>
import BaseEarth from '../map/utils/Earth.js'
import TWEEN from '@tweenjs/tween.js'
import * as THREE from 'three'
import {
    GUI
} from 'three/examples/jsm/libs/lil-gui.module.min.js'
import {
    random
} from '../map/utils'
import useFileLoader from '../map/hooks/useFileLoader.js'
import useCountry from '../map/hooks/useCountry.js'
import useCoord from '../map/hooks/useCoord.js'
import useConversionStandardData from '../map/hooks/useConversionStandardData.js'
import useMarkedLightPillar from '../map/hooks/map/useMapMarkedLightPillar.js'
import useSequenceFrameAnimate from '../map/hooks/useSequenceFrameAnimate.js'
import useCSS2DRender from '../map/hooks/useCSS2DRender.js'

const {
    requestData
} = useFileLoader()
const {
    transfromGeoJSON
} = useConversionStandardData()
const {
    getBoundingBox
} = useCoord()
const {
    createCountryFlatLine
} = useCountry()
const {
    initCSS2DRender,
    create2DTag
} = useCSS2DRender()
const {
    createLightPillar
} = useMarkedLightPillar({
    scaleFactor: 1.2,
})
// 序列帧
const {
    createSequenceFrame
} = useSequenceFrameAnimate()
let centerXY = [106.59893798828125, 26.918846130371094]
let depth = 0.1
const bottomZ = -0.2

let baseEarth = null
let particleArr = null
let topFaceMaterial = null
let sideMaterial = null
let mapGroups = null
let threeScene = null
let rotatingApertureTexture = null
let rotatingPointTexture = null
let sceneBg = null
let circlePoint = null
let textureMap = null
let texturefxMap = null
export default {
    data() {
        return {}
    },
    methods: {
        resize() {
            baseEarth.resize()
        },

        initGui() {
            const gui = new GUI()
            const guiParams = {
                topColor: '#b4eeea',
                sideColor: '#123024',
                scale: 0.1,
            }
            gui.addColor(guiParams, 'topColor').onChange((val) => {
                topFaceMaterial.color = new THREE.Color(val)
            })
            gui.addColor(guiParams, 'sideColor').onChange((val) => {
                sideMaterial.color = new THREE.Color(val)
            })
            gui.add(guiParams, 'scale', 0, 1).onChange((val) => {
                textureMap.repeat.set(val, val)
                texturefxMap.repeat.set(val, val)
            })
        },

        // 初始化旋转光圈
        initRotatingAperture(scene, width) {
            let plane = new THREE.PlaneGeometry(width, width)
            let material = new THREE.MeshBasicMaterial({
                map: rotatingApertureTexture,
                transparent: true,
                opacity: 1,
                depthTest: true,
            })
            let mesh = new THREE.Mesh(plane, material)
            mesh.position.set(...centerXY, 0)
            mesh.scale.set(1.1, 1.1, 1.1)
            scene.add(mesh)
            return mesh
        },
        // 初始化旋转点
        initRotatingPoint(scene, width) {
            let plane = new THREE.PlaneGeometry(width, width)
            let material = new THREE.MeshBasicMaterial({
                map: rotatingPointTexture,
                transparent: true,
                opacity: 1,
                depthTest: true,
            })
            let mesh = new THREE.Mesh(plane, material)
            mesh.position.set(...centerXY, bottomZ - 0.02)
            mesh.scale.set(1.1, 1.1, 1.1)
            scene.add(mesh)
            return mesh
        },
        // 初始化背景
        initSceneBg(scene, width) {
            let plane = new THREE.PlaneGeometry(width * 4, width * 4)
            let material = new THREE.MeshPhongMaterial({
                // color: 0x061920,
                color: 0xffffff,
                map: sceneBg,
                transparent: true,
                opacity: 1,
                depthTest: true,
            })

            let mesh = new THREE.Mesh(plane, material)
            mesh.position.set(...centerXY, bottomZ - 0.2)
            scene.add(mesh)
        },
        // 初始化原点
        initCirclePoint(scene, width) {
            let plane = new THREE.PlaneGeometry(width, width)
            let material = new THREE.MeshPhongMaterial({
                color: 0x00ffff,
                map: circlePoint,
                transparent: true,
                opacity: 1,
                // depthTest: false,
            })
            let mesh = new THREE.Mesh(plane, material)
            mesh.position.set(...centerXY, bottomZ - 0.1)
            // let mesh2 = mesh.clone()
            // mesh2.position.set(...centerXY, bottomZ - 0.001)
            scene.add(mesh)
        },
        // 初始化粒子
        initParticle(scene, bound) {
            // 获取中心点和中间地图大小
            let {
                center,
                size
            } = bound
            // 构建范围，中间地图的2倍
            let minX = center.x - size.x
            let maxX = center.x + size.x
            let minY = center.y - size.y
            let maxY = center.y + size.y
            let minZ = -6
            let maxZ = 6

            particleArr = []
            for (let i = 0; i < 16; i++) {
                const particle = createSequenceFrame({
                    image: './data/map/particle.png',
                    width: 180,
                    height: 189,
                    frame: 9,
                    column: 9,
                    row: 1,
                    speed: 0.5,
                })
                let particleScale = random(5, 10) / 1000
                particle.scale.set(particleScale, particleScale, particleScale)
                particle.rotation.x = Math.PI / 2
                let x = random(minX, maxX)
                let y = random(minY, maxY)
                let z = random(minZ, maxZ)
                particle.position.set(x, y, z)
                particleArr.push(particle)
            }
            scene.add(...particleArr)
        },
        // 创建顶部底部边线
        initBorderLine(data, mapGroup) {
            let lineTop = createCountryFlatLine(
                data, {
                    color: 0xffffff,
                    linewidth: 0.0015,
                    transparent: true,
                    depthTest: false,
                },
                'Line2'
            )
            lineTop.position.z += 0.305
            let lineBottom = createCountryFlatLine(
                data, {
                    color: 0x61fbfd,
                    linewidth: 0.002,
                    // transparent: true,
                    depthTest: false,
                },
                'Line2'
            )
            lineBottom.position.z -= 0.1905
            //  添加边线
            mapGroup.add(lineTop)
            mapGroup.add(lineBottom)
        },
        // 创建光柱
        initLightPoint(properties, mapGroup) {
            // 创建光柱
            let heightScaleFactor = 0.4 + random(1, 5) / 5
            let lightCenter = properties.centroid || properties.center

            let light = createLightPillar(...lightCenter, heightScaleFactor)
            light.position.z = 0.31
            if (properties.name === '额敏县') {
                light.position.z = 0.31 + depth * 2 // 额敏县的光柱高度
            }
            mapGroup.add(light)
        },
        // 创建标签
        initLabel(properties, scene) {
            // 设置标签的显示内容和位置
            var label = create2DTag(this.$t('标签'), 'map-32-label')
            scene.add(label)
            let labelCenter = properties.centroid //centroid || properties.center
            label.show(properties.name, new THREE.Vector3(...labelCenter, 0.1))
        },
    },
    async mounted() {
        var that = this
        const texture = new THREE.TextureLoader()
        textureMap = texture.load('/data/map/gz-map.jpg')
        texturefxMap = texture.load('/data/map/gz-map-fx.jpg')
        rotatingApertureTexture = texture.load('/data/map/rotatingAperture.png')
        rotatingPointTexture = texture.load('/data/map/rotating-point2.png')
        circlePoint = texture.load('/data/map/circle-point.png')
        sceneBg = texture.load('/data/map/scene-bg2.png')
        textureMap.wrapS = texturefxMap.wrapS = THREE.RepeatWrapping
        textureMap.wrapT = texturefxMap.wrapT = THREE.RepeatWrapping
        textureMap.flipY = texturefxMap.flipY = false
        textureMap.rotation = texturefxMap.rotation = THREE.MathUtils.degToRad(45)
        
        const scale = 0.128
        textureMap.repeat.set(scale, scale)
        texturefxMap.repeat.set(scale, scale)

        
        topFaceMaterial = new THREE.MeshPhongMaterial({
            map: textureMap,
            color: 0x35e9e6,
            combine: THREE.MultiplyOperation,
            transparent: true,
            opacity: 1,
        })
        sideMaterial = new THREE.MeshLambertMaterial({
            color: 0x123024,
            transparent: true,
            opacity: 0.9,
        })

        // 顶部高亮材质（移除未初始化的envMap）
        let highlightTopMaterial = new THREE.MeshStandardMaterial({
            color: 0x40c4ff, // 浅蓝，降低饱和度
            metalness: 0.8,
            roughness: 0.05, // 高光滑度
            emissive: 0x20a0ff,
            emissiveIntensity: 0.3,
            transparent: false,
            opacity: 1
        });

        // 侧边高亮材质（保持PBR属性）
        let highlightSideMaterial = new THREE.MeshStandardMaterial({
            color: 0x0055aa, // 深一点的蓝，与顶部形成层次
            metalness: 0.6,
            roughness: 0.3, // 轻微粗糙
            emissive: 0x003388,
            emissiveIntensity: 0.1,
            transparent: false,
            opacity: 1
        });

        // 数据
        let provinceData = await requestData('/data/map/tacheng.json')
        provinceData = transfromGeoJSON(provinceData)

        class CurrentEarth extends BaseEarth {
            constructor(props) {
                super(props)
            }

            initCamera() {
                let {
                    width,
                    height
                } = this.options
                let rate = width / height
                threeScene = this.scene
                // 设置45°的透视相机,更符合人眼观察
                this.camera = new THREE.PerspectiveCamera(45, rate, 1, 90000000)
                this.camera.up.set(0, 0, 1)
                // 北京
                this.camera.position.set(86.36195827987267, 39.3832071569889, 5.082652021718718) //相机在Three.js坐标系中的位置
                this.camera.lookAt(...centerXY, 0)
                console.log(this.camera.position)
            }

            initModel() {
                try {
                    // 创建组
                    mapGroups = new THREE.Group()
                    // 标签 初始化
                    this.css2dRender = initCSS2DRender(this.options, this.container)
                    provinceData.features.forEach((elem, index) => {
                        // 定一个省份对象
                        const province = new THREE.Object3D()
                        // 坐标
                        const coordinates = elem.geometry.coordinates
                        // city 属性
                        const properties = elem.properties

                        // 循环坐标
                        coordinates.forEach((multiPolygon) => {
                            multiPolygon.forEach((polygon) => {
                                const shape = new THREE.Shape()
                                // 绘制shape
                                for (let i = 0; i < polygon.length; i++) {
                                    let [x, y] = polygon[i]
                                    if (i === 0) {
                                        shape.moveTo(x, y)
                                    }
                                    shape.lineTo(x, y)
                                }
                                // 拉伸设置
                                const extrudeSettings = {
                                    depth: depth,
                                    bevelEnabled: true,
                                    bevelSegments: 1,
                                    bevelThickness: 0.1,
                                }
                                if (properties.name === '额敏县') {
                                    extrudeSettings.depth = depth * 3
                                }

                                const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)
                                const mesh = properties.name === '额敏县' ?
                                    new THREE.Mesh(geometry, [highlightTopMaterial, highlightSideMaterial]) :
                                    new THREE.Mesh(geometry, [topFaceMaterial, sideMaterial])
                                province.add(mesh)

                            })
                        })

                        mapGroups.add(province)
                        // 创建标点和标签
                        that.initLightPoint(properties, mapGroups)
                        that.initLabel(properties, threeScene)
                    })
                    // 创建上下边框
                    that.initBorderLine(provinceData, mapGroups)

                    let earthGroupBound = getBoundingBox(mapGroups)
                    centerXY = [earthGroupBound.center.x, earthGroupBound.center.y]
                    let {
                        size
                    } = earthGroupBound
                    let width = size.x < size.y ? size.y + 1 : size.x + 1
                    // 添加背景，修饰元素
                    this.rotatingApertureMesh = that.initRotatingAperture(threeScene, width)
                    this.rotatingPointMesh = that.initRotatingPoint(threeScene, width - 2)
                    that.initCirclePoint(threeScene, width)
                    that.initSceneBg(threeScene, width)

                    // 将组添加到场景中
                    threeScene.add(mapGroups)
                    that.initParticle(threeScene, earthGroupBound)
                    // that.initGui()
                } catch (error) {
                    console.log(error)
                }
            }

            initControls() {
                super.initControls()
                this.controls.target = new THREE.Vector3(...centerXY, 0)
            }

            initLight() {
                //   平行光1
                let directionalLight1 = new THREE.DirectionalLight(0xa8d8ea, 1)
                directionalLight1.position.set(...centerXY, 30)
                //   平行光2
                let directionalLight2 = new THREE.DirectionalLight(0xa8d8ea, 1)
                directionalLight2.position.set(...centerXY, 30)
                // 环境光
                let ambientLight = new THREE.AmbientLight(0xa8d8ea, 1)
                // 将光源添加到场景中
                this.addObject(directionalLight1)
                this.addObject(directionalLight2)
                this.addObject(ambientLight)
            }

            initRenderer() {
                super.initRenderer()
                // this.renderer.outputEncoding = THREE.sRGBEncoding
            }

            loop() {
                this.animationStop = window.requestAnimationFrame(() => {
                    this.loop()
                })
                // 这里是你自己业务上需要的code
                this.renderer.render(threeScene, this.camera)
                // 控制相机旋转缩放的更新
                if (this.options.controls.visibel && this.controls) {
                    // this.controls.target.set(...centerXY, 0)
                    this.controls.update()
                }
                // 统计更新
                // if (this.options.statsVisibel) this.stats.update()
                if (this.rotatingApertureMesh) {
                    this.rotatingApertureMesh.rotation.z += 0.0005
                }
                if (this.rotatingPointMesh) {
                    this.rotatingPointMesh.rotation.z -= 0.0005
                }
                // 渲染标签
                if (this.css2dRender) {
                    this.css2dRender.render(threeScene, this.camera)
                }
                // 粒子上升
                if (particleArr.length) {
                    for (let i = 0; i < particleArr.length; i++) {
                        particleArr[i].updateSequenceFrame()
                        particleArr[i].position.z += 0.01
                        if (particleArr[i].position.z >= 6) {
                            particleArr[i].position.z = -6
                        }
                    }
                }
                TWEEN.update()
                // console.log(this.camera.position)
            }

            resize() {
                super.resize()
                // 这里是你自己业务上需要的code
                this.renderer.render(threeScene, this.camera)
                this.renderer.setPixelRatio(window.devicePixelRatio)

                if (this.css2dRender) {
                    this.css2dRender.setSize(this.options.width, this.options.height)
                }
            }
        }

        baseEarth = new CurrentEarth({
            container: '#app-32-map',
            axesVisibel: true,
            controls: {
                enableDamping: true, // 阻尼
                maxPolarAngle: (Math.PI / 2) * 0.98,
            },
        })
        baseEarth.run()

        window.addEventListener('resize', this.resize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize)
    },
}
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    position: fixed;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-direction: column;

    .is-full {
        position: relative;
        width: 100%;
        height: 100%;
    }
}
</style>

<style>
.map-32-label {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
</style>
